import React from "react";

import { H1, H2, H3, Text } from "@salt-ds/core";
import {
  ACH_SESSION_PAGE_H1,
  ACH_SESSION_PAGE_H2,
  ACH_SESSION_PAGE_H3,
  ACH_SESSION_PAGE_STEP1,
  ACH_SESSION_PAGE_STEP2,
} from "src/utils/Constants";

const SessionTimeoutPage: React.FC = () => {
  return (
    <div className="w-[684px] mx-auto flex items-center justify-center">
      <div className=" flex-col  justify-center gap-10 inline-flex mt-[24px]">
        <div className=" bg-white flex-col justify-start items-start gap-6 inline-flex">
          <div className="  flex-col justify-start  inline-flex ">
            <H1>{ACH_SESSION_PAGE_H1}</H1>

            <div className=" flex-col justify-start items-start gap-2 inline-flex mt-[24px]">
              <H2>{ACH_SESSION_PAGE_H2}</H2>
            </div>
            <div className="h-4 flex-col justify-start items-start gap-2 inline-flex mt-[24px]">
              <H3>{ACH_SESSION_PAGE_H3}</H3>
              <Text className="flex flex-col gap-2">
                <span>{ACH_SESSION_PAGE_STEP1}</span>
                <span>{ACH_SESSION_PAGE_STEP2}</span>
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SessionTimeoutPage;
